import React from "react";
import { formatLocalDateTime } from "../../../utils/dateTime";

const LiveMonitoringPanel = ({
    hidden,
    status,
    statusLabel,
    windowMinutes,
    refreshSeconds,
    windows,
    intervals,
    enabled,
    paused,
    followLatest,
    pageHidden,
    updatedAt,
    warning,
    message,
    loading,
    windowLabel,
    onWindowChange,
    onRefreshChange,
    onToggleEnabled,
    onTogglePaused,
    onFollowLatest,
}) => (
    <section
        className="graph-page__card"
        role="tabpanel"
        id="history-panel-live"
        aria-labelledby="history-tab-live"
        hidden={hidden}
    >
        <div className="graph-page__card-head graph-page__card-head--split">
            <div>
                <h2 id="live-monitoring-heading">Live monitoring</h2>
                <p>Live stays off until you enable it. The window and refresh are remembered, and a reload does not start requests.</p>
            </div>
            <span className={`graph-page__status is-${status}`} role="status" aria-live="polite">{statusLabel}</span>
        </div>
        <div className="graph-page__live-grid">
            <div className="graph-page__field">
                <label htmlFor="live-window">Window</label>
                <select id="live-window" value={windowMinutes} onChange={(event) => onWindowChange(Number(event.target.value))}>
                    {windows.map((minutes) => <option key={minutes} value={minutes}>{windowLabel(minutes)}</option>)}
                </select>
            </div>
            <div className="graph-page__field">
                <label htmlFor="live-refresh">Refresh</label>
                <select id="live-refresh" value={refreshSeconds} onChange={(event) => onRefreshChange(Number(event.target.value))}>
                    {intervals.map((seconds) => <option key={seconds} value={seconds}>{seconds} seconds</option>)}
                </select>
            </div>
        </div>
        <div className="graph-page__actions">
            <button type="button" className={`graph-page__button${enabled ? "" : " graph-page__button--primary"}`} aria-pressed={enabled} onClick={onToggleEnabled} disabled={loading && !enabled}>
                {enabled ? "Disable Live" : "Enable Live"}
            </button>
            <button type="button" className="graph-page__button" onClick={onTogglePaused} disabled={!enabled} aria-pressed={paused}>
                {paused ? "Resume" : "Pause"}
            </button>
            <button type="button" className="graph-page__button" onClick={onFollowLatest} disabled={!enabled} aria-pressed={enabled && followLatest}>
                Follow Latest
            </button>
        </div>
        <p className="graph-page__live-note">Last successful update: {updatedAt ? formatLocalDateTime(updatedAt) : "None yet"}</p>
        <p className="graph-page__live-note">
            Each refresh reconciles persisted history rows by id. An ON_CHANGE end row keeps its id and moves to the timestamp returned by the history API. The next request starts only after the current one finishes and the refresh interval has elapsed. A {refreshSeconds}-second setting does not guarantee {refreshSeconds}-second freshness when history is slower.
        </p>
        {enabled && !followLatest && <p className="graph-page__live-note">New samples stay in view while the right edge is on the latest sample. Pan away from that edge to hold the range. Follow Latest restores the full window.</p>}
        {enabled && !paused && pageHidden && <p className="graph-page__live-note">Automatic refresh is paused while this browser tab is hidden.</p>}
        {warning && <p className="graph-page__banner is-warn" role="status">{warning}</p>}
        {message && <p className="graph-page__banner is-error" role="alert">{message}</p>}
    </section>
);

export default LiveMonitoringPanel;
